import { render, staticRenderFns } from "./ModalLogHistory.vue?vue&type=template&id=0c4a6eec"
import script from "./ModalLogHistory.vue?vue&type=script&lang=js"
export * from "./ModalLogHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports